import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import heroImage from './img/hero-img.avif';
import css from './AudiencePage.module.css';

const SectionHero = () => {
  return (
    <div className={css.heroContainer}>
      <div className={css.heroContent}>
        <h1 className={css.heroTitle}>
          <FormattedMessage id="AudiencePage.heroTitle" />
        </h1>
        <img className={css.heroImage} src={heroImage} alt="Start involving" />
      </div>
    </div>
  );
};

export default SectionHero;
